module.exports = __webpack_public_path__ + "lf-bm.jpg?0c107dc88218566b7255ec2155d35ea3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lf-bm.jpg
// module id = 221
// module chunks = 0